/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Add new reportt page
  Date: June 22, 2020
**/

import React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import {
  makeStyles,
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  TextField,
  Button,
  FormHelperText,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  Typography,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Formik, FieldArray, Field } from 'formik';
import * as Yup from 'yup';
import { stringConstants } from '../../constants/stringConstants';
import * as applicationConstants from '../../constants/applicationConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import styles from './reportAdd.module.scss';

import RenderField from './RenderField';
import { ReportDetails } from './ReportDetails';
import { QueryDetails } from './QueryDetails';

/** STYLES HERE * */
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    marginLeft: '0px',
    width: '100%',
  },
  mainPadding: {
    padding: '0 20px',
  },
  attachFile: {
    paddingTop: '30px !important',
  }
}));
// dynamic field filter
const FieldCommon = (props) => {
  const customizeState = useStoreState((state) => state.customize);
  const settingsState = useStoreState((state) => state.settings);
  const businessLineList = useStoreState((state) => {
    return state.businessLine.businessLineList
  });
  const clientList = useStoreState((state) => {
    return state.client?.clientList;
  });
  const programList = useStoreState((state) => state.programs.programList);

  let collectionType = [];
  let collectionTitle = '';
  if (props.dataCollectionType == 'entity-groups-client_id' || props.dataCollectionType == 'asso-groups-client_id') {
    collectionTitle = 'Client Name';
    collectionType = customizeState.clientsList;
  }
  if (props.dataCollectionType == 'entity-programs-sourcing' || props.dataCollectionType == 'asso-programs-sourcing') {
    collectionTitle = 'Type';
    collectionType = settingsState.vendorList;
  }

  if (props.dataCollectionType == 'entity-policies-record_type' || props.dataCollectionType == 'asso-policies-record_type') {
    collectionTitle = 'Type';
    collectionType = settingsState.policyTypeList;
  }

  if (props.dataCollectionType == 'asso-businesslines-title' || props.dataCollectionType == 'entity-businesslines-title' || props.dataCollectionType == 'entity-policies-lob_title') {
    collectionTitle = 'BusinessLine List'
    collectionType = businessLineList.map((element) => {
      return { title: element.title, PK: element.title }
    });

    return (<Field name={props.name} title={collectionTitle} data={collectionType} type="multi-select" component={RenderField} />);
  }

  if (props.dataCollectionType == 'asso-clients-title' || props.dataCollectionType == 'entity-clients-title') {
    collectionTitle = 'Clients'
    collectionType = clientList.map((element) => {
      return { title: element.title, PK: element.title }
    });

    return (<Field name={props.name} title={collectionTitle} data={collectionType} type="multi-select" component={RenderField} />);
  }

  if (props.dataCollectionType == 'asso-programs-shortname' || props.dataCollectionType == 'entity-programs-shortname') {
    collectionTitle = 'Programs'
    collectionType = programList.map((element) => {
      return { title: element.shortname, PK: element.shortname }
    });
    return (<Field name={props.name} title={collectionTitle} data={collectionType} type="multi-select" component={RenderField} />);
  }

  if (props.dataCollectionType == 'asso-programs-title' || props.dataCollectionType == 'entity-programs-title') {
    collectionTitle = 'Programs'
    collectionType = programList.map((element) => {
      return { title: element.title, SK: element.title }
    });
  }

  if (props.dataCollectionType == 'entity-instructions-record_type' || props.dataCollectionType == 'asso-instructions-record_type') {
    collectionTitle = 'Type';
    collectionType = [{ title: 'Group', SK: 'GROUP' }, { title: 'Policy', SK: 'POLICY' }, { title: 'Procedure', SK: 'PROCEDURE' }, { title: 'Program', SK: 'PROGRAM' }, { title: 'Business', SK: 'BUSINESS' }];
  }

  if (props.dataCollectionType == 'entity-procedures-record_type' || props.dataCollectionType == 'asso-procedures-record_type') {
    collectionTitle = 'Type';
    collectionType = applicationConstants.ProcedureRecordTypeList.map((recordType) => {
      return { title: recordType, SK: recordType }
    });
  }



  if (props.dataCollectionType == 'entity-transactions-procedure_codes' || props.dataCollectionType == 'entity-procedures-record_number' || props.dataCollectionType == 'asso-procedures-record_number') {
    return (<Field name={props.name} title={collectionTitle} data={props.chipsTags} type="tags" component={RenderField} {...props} />);
  } else {
    return (<Field name={props.name} title={collectionTitle} data={collectionType} type="custom-type" component={RenderField} />);
  }
}

const ReportAddage = (props) => {
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  const { history } = props;
  const [entityType, setEntityType] = React.useState('');
  const [associationType, setAssociationType] = React.useState('');
  const settingsAction = useStoreActions((action) => action.settings);
  const businessLineAction = useStoreActions((actions) => actions.businessLine);
  const clientAction = useStoreActions((actions) => actions.client);
  const programAction = useStoreActions((actions) => actions.programs);


  const [dropdownList, setDropdownList] = React.useState([]); // Checked value added in dropdown list
  const [associationList, setAssociationList] = React.useState([]); // Checked value added in dropdown list
  const [associationFieldList, setAssociationFieldList] = React.useState([]); // Checked value added in dropdown list
  const [entityFieldList, setEntityFieldList] = React.useState([]); // Checked value added in dropdown list

  //For Expansion Panels
  const [expandAddForm, setExpandAddForm] = React.useState(true);
  const [expandEntities, setExpandEntities] = React.useState(false);
  const [expandFilters, setExpandFilters] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [chipsTags, setChipsTags] = React.useState([]);
  const [detectAssociationChange, setDetectAssociationChange] = React.useState(false);
  const [entityTypeListJson, setEntityTypeListJson] = React.useState(false);
  const [associationTypeListJson, setAssociationTypeListJson] = React.useState(false);

  const [saved] = React.useState(false);

  // Add Chips
  const handleAddChip = (chip) => {
    setChipsTags([...chipsTags, chip]);
  }
  // Delete Chips
  const handleDeleteChip = (chip) => {
    setChipsTags(chipsTags.filter(function (item) { return item !== chip }));
  }
  // for operate type
  const operationList = [
    {
      label: "=",
      name: "date"
    },
    {
      label: "<=",
      name: "date_ltq"
    },
    {
      label: ">=",
      name: "date_gtq"
    },
    {
      label: "Between",
      name: "range"
    },
    {
      label: "Month",
      name: "month"
    },
    {
      label: "=",
      name: "equals"
    },
    {
      label: "Between",
      name: "between"
    },
    {
      label: "Like",
      name: "like"
    },
    {
      label: "Includes",
      name: "in"
    },
    {
      label: "Null",
      name: "null"
    },
  ];
  const classes = useStyles();
  // Form field value define
  const [fieldData, setFieldData] = React.useState({
    title: '',
    is_public: '',
    version: '',
    description: '',
    data_type: '',
    association_type: '',
    filterFields: [

    ],
    count: '',
    field: '',
    isSavePreview: false
  });
  // Validation Schema for formik
  const schema = Yup.object().shape({
    title: Yup.string().required(stringConstants.requiredValidationMsg).max(30),
    version: Yup.string().required(stringConstants.requiredValidationMsg),
    is_public: Yup.string().required(stringConstants.requiredValidationMsg),
    data_type: Yup.string().required(stringConstants.requiredValidationMsg),

    filterFields: Yup.array()
      .of(
        Yup.object().shape({
          operation: Yup.string(),
          value: Yup.string().test("startTest", stringConstants.requiredValidationMsg, function(val) {

            if (['date', 'date_ltq', 'date_gtq', 'range'].includes(this.parent.operation)) {
              if (!val) return false;
            }
            return true;
          }),         
        })
      )
  });

  // for filter list binding
  let boundArrayHelpers = {};
  const bindArrayHelpers = (arrayHelpers) => {
    boundArrayHelpers = arrayHelpers //NO SONAR
  }

  /** Filter Combination Payload Method **/

  const onFormSubmit = async (values, { resetForm, setErrors }) => {    
    
  };
  // Checkbox array with different entities

  React.useEffect(() => {
    // set association type dropdown list
    if (entityType) {
      if (reportState.entityTypeList && reportState.entityTypeList[entityType] && reportState.entityTypeList[entityType].associations) {
        // for entity meta field
        const dataListEntity = reportState.entityTypeList[entityType];
        if (dataListEntity.meta && dataListEntity.meta.length > 0) {
          const metaDataListEntity = dataListEntity.meta
            .filter(filterVal => {
              return (entityType === 'groups' && filterVal.name !== 'entity-groups-pa_status' && filterVal.name !== 'entity-groups-optin_status') ||
                (entityType === 'businesslines' && filterVal.name !== 'entity-businesslines-optin_status') ||
                (entityType === 'clients' && filterVal.name !== 'entity-clients-optin_status') ||
                (entityType === 'programs' && filterVal.name !== 'entity-programs-pa_status' && filterVal.name !== 'entity-programs-optin_status' && filterVal.name !== 'entity-programs-clinical_criteria' && filterVal.name !== 'entity-programs-dual_managed') ||
                (entityType === 'instructions') ||
                (entityType === 'procedures' && filterVal.name !== 'entity-procedures-pa_status' && filterVal.name !== 'entity-procedures-dual_managed' && filterVal.name !== 'entity-procedures-effectivedate' && filterVal.name !== 'entity-procedures-inactivedate') ||
                (entityType === 'policies' && filterVal.name !== 'entity-policies-pa_status' && filterVal.name !== 'entity-policies-effectivedate' && filterVal.name !== 'entity-policies-inactivedate') ||
                (entityType === 'transactions') || (entityType === 'members')
            })
            .map((val) => {
              val.checked = false;
              return val
            });
          setEntityFieldList(metaDataListEntity);
        } else {
          setEntityFieldList([]);
        }

        // for association meta field
        const dataListAssociations = reportState.entityTypeList[entityType].associations;
        if (dataListAssociations.length > 0) {
          const labelList = dataListAssociations.map((val) => {
            return { name: val, label: reportState.entityTypeList[val] && reportState.entityTypeList[val].label }
          });
          setAssociationList(labelList);
        } else {
          setAssociationList([]);
        }
      }
    }
  }, [entityType]);

  React.useEffect(() => {
    // set association meta field list
    if (associationType) {
      if (reportState.entityTypeList && reportState.associationTypeList[associationType]) {
        const dataList = reportState.associationTypeList[associationType];
        if (dataList.meta && dataList.meta.length > 0) {
          const metaDataList = dataList.meta.filter((filterVal) => {
            return (entityType === 'policies' && associationType === 'policies_version') ||
              (entityType === 'policies' && associationType === 'instructions') ||
              (entityType === 'policies' && associationType === 'procedures' && filterVal.name !== 'asso-procedures-dual_managed') ||
              (entityType === 'groups' && associationType === 'programs' && filterVal.name !== 'asso-programs-pa_status' && filterVal.name !== 'asso-programs-clinical_criteria' && filterVal.name !== 'asso-programs-dual_managed') ||
              (entityType === 'groups' && associationType === 'businesslines' && filterVal.name !== 'asso-businesslines-optin_status') ||
              (entityType === 'groups' && associationType === 'clients' && filterVal.name !== 'asso-clients-optin_status') ||
              (entityType === 'groups' && associationType === 'instructions') ||
              (entityType === 'groups' && associationType === 'procedures' && filterVal.name !== 'asso-procedures-dual_managed') ||
              (entityType === 'businesslines' && associationType === 'programs' && filterVal.name !== 'asso-programs-pa_status' && filterVal.name !== 'asso-programs-clinical_criteria' && filterVal.name !== 'asso-programs-dual_managed') ||
              (entityType === 'businesslines' && associationType === 'groups' && filterVal.name !== 'asso-groups-prior_auth_exumption' && filterVal.name !== 'asso-groups-pa_status' && filterVal.name !== 'asso-groups-optin_status') ||
              (entityType === 'businesslines' && associationType === 'instructions') ||
              (entityType === 'businesslines' && associationType === 'procedures' && filterVal.name !== 'asso-procedures-dual_managed') ||
              (entityType === 'clients' && associationType === 'programs' && filterVal.name !== 'asso-programs-pa_status' && filterVal.name !== 'asso-programs-clinical_criteria' && filterVal.name !== 'asso-programs-dual_managed') ||
              (entityType === 'clients' && associationType === 'groups' && filterVal.name !== 'asso-groups-prior_auth_exumption' && filterVal.name !== 'asso-groups-pa_status' && filterVal.name !== 'asso-groups-optin_status') ||
              (entityType === 'clients' && associationType === 'instructions') ||
              (entityType === 'clients' && associationType === 'procedures' && filterVal.name !== 'asso-procedures-dual_managed') ||
              (entityType === 'programs' && associationType === 'businesslines' && filterVal.name !== 'asso-businesslines-prior_auth_exumption') ||
              (entityType === 'programs' && associationType === 'clients') ||
              (entityType === 'programs' && associationType === 'groups' && filterVal.name !== 'asso-groups-prior_auth_exumption' && filterVal.name !== 'asso-groups-pa_status') ||
              (entityType === 'programs' && associationType === 'instructions') ||
              (entityType === 'programs' && associationType === 'procedures') ||
              (entityType === 'instructions' && associationType === 'businesslines' && filterVal.name !== 'asso-businesslines-optin_status') ||
              (entityType === 'instructions' && associationType === 'clients' && filterVal.name !== 'asso-clients-optin_status') ||
              (entityType === 'instructions' && associationType === 'programs' && filterVal.name !== 'asso-programs-pa_status' && filterVal.name !== 'asso-programs-optin_status' && filterVal.name !== 'asso-programs-dual_managed') ||
              (entityType === 'instructions' && associationType === 'groups' && filterVal.name !== 'asso-groups-pa_status' && filterVal.name !== 'asso-groups-optin_status') ||
              (entityType === 'instructions' && associationType === 'policies' && filterVal.name !== 'asso-policies-pa_status' && filterVal.name !== 'asso-policies-lob_title') ||
              (entityType === 'procedures' && associationType === 'policies' && filterVal.name !== 'asso-policies-lob_title') ||
              (entityType === 'procedures' && associationType === 'groups' && filterVal.name !== 'asso-groups-prior_auth_exumption' && filterVal.name !== 'asso-groups-optin_status') ||
              (entityType === 'procedures' && associationType === 'businesslines' && filterVal.name !== 'asso-businesslines-optin_status' && filterVal.name !== 'asso-businesslines-prior_auth_exumption') ||
              (entityType === 'procedures' && associationType === 'clients' && filterVal.name !== 'asso-clients-optin_status') ||
              (entityType === 'procedures' && associationType === 'programs' && filterVal.name !== 'asso-programs-clinical_criteria' && filterVal.name !== 'asso-programs-optin_status')
          }).map((val) => {
            val.checked = false;
            return val
          });

          setAssociationFieldList(metaDataList);
        } else {
          setAssociationFieldList([]);
        }
      }
      // reset dropdown list
      if (detectAssociationChange) {
        let filteredArray = dropdownList.filter(item => item.name.includes('asso-') === false);
        setDropdownList(filteredArray);
      }
      setDetectAssociationChange(true);
    }
  }, [associationType]);

  React.useEffect(() => {
    const URL = location.hostname === 'localhost' ? "http://localhost:3000/schema.json" : `${process.env.REACT_APP_URL}/schema.json`;
    reportAction
      .getEntityTypeList(URL)
      .then(function (response) {
        setEntityTypeListJson(true);
      })
      .catch(function (error) {
        console.log("error", error);
      });
    reportAction
      .getAssociationTypeList(URL)
      .then(function (response) {
        setAssociationTypeListJson(true);
      })
      .catch(function (error) {
        console.log("error", error);
      });
    
    // get clients
    // customizeAction.getCustomTypesList('client');
    // get sourcing
    // customizeAction.getCustomTypesList('sourcing');
    settingsAction.getVendorList();
    // get policy
    // customizeAction.getCustomTypesList('policy');
    settingsAction.getPolicyTypeList();

    //get line of Business
    businessLineAction.getBusinessLineList('purpose=listing');

    //get Client list
    clientAction.getClientList('purpose=listing');

    //get program
    programAction.getProgramList('purpose=listing');

    // get source list
    reportAction.getSourceList();
    
  }, []);

  React.useEffect(() => {
    if (entityTypeListJson === true && associationTypeListJson === true) {
      // edit report
      if (props.match && props.match.params.id) {
        reportAction
          .getCustomReport(props.match.params.id).then(function (response) {
            setIsLoaded(true);
            if (response.payload && response.payload.error) {
              setEmptyRecord(true)
            }
          });
      } else {
        setIsLoaded(true);
      }
    }
  }, [entityTypeListJson, associationTypeListJson]);

  React.useEffect(() => {
    // set association meta field list
    if (reportState.customReport) {
      let obj = reportState.customReport;
      obj.metaFields = {};
      if (obj.query) {
        if (obj.query.entity && obj.query.entity.type) {
          obj.data_type = obj.query.entity.type;
          setEntityType(obj.data_type);
          obj.query.entity.metafields && obj.query.entity.metafields.map((val) => { val = 'entity-' + obj.data_type + '-' + val; obj.metaFields[val] = true; return { [val]: true } });

          if (reportState.entityTypeList && reportState.entityTypeList[obj.data_type]) {
            const dataListEntity = reportState.entityTypeList[obj.data_type];
            if (dataListEntity.meta && dataListEntity.meta.length > 0) {
              const metaDataListEntity = dataListEntity.meta.map((val) => {
                if (Object.keys(obj.metaFields).includes(val.name)) {
                  val.checked = true;
                  val.isChecked = true;
                }
                return val
              });
              setEntityFieldList(metaDataListEntity);
            } else {
              setEntityFieldList([]);
            }
          }
        }
        if (obj.query.associatedentity && obj.query.associatedentity.type) {
          // Entity 2
          obj.association_type = obj.query.associatedentity.type;
          setAssociationType(obj.association_type);
          obj.query.associatedentity.metafields && obj.query.associatedentity.metafields.map((val) => { val = 'asso-' + obj.association_type + '-' + val; obj.metaFields[val] = true; return { [val]: true } });

          if (reportState.associationTypeList && reportState.associationTypeList[obj.association_type]) {
            const dataList = reportState.associationTypeList[obj.association_type];
            if (dataList.meta && dataList.meta.length > 0) {
              const metaDataList = dataList.meta.map((val) => {
                if (Object.keys(obj.metaFields).includes(val.name)) {
                  val.checked = true;
                  val.isChecked = true;
                }
                return val
              });
              setAssociationFieldList(metaDataList);
            } else {
              setAssociationFieldList([]);
            }
          }
        }

        if (obj.query.filters) {
          const dropdownListArr = [];
          if (obj.metaFields && Object.keys(obj.metaFields).length > 0) {
            Object.keys(obj.metaFields).forEach((objVal) => {
              if (reportState.entityTypeList[obj.query.entity.type] && reportState.entityTypeList[obj.query.entity.type].meta && reportState.entityTypeList[obj.query.entity.type].meta.filter(filterVal => filterVal.name == objVal).length > 0) {
                let valType = reportState.entityTypeList[obj.query.entity.type].meta.filter(filterVal => filterVal.name == objVal)[0];
                dropdownListArr.push(valType);
              }

              if (obj.query?.associatedentity?.type && reportState.associationTypeList[obj.query.associatedentity.type] && reportState.associationTypeList[obj.query.associatedentity.type].meta && reportState.associationTypeList[obj.query.associatedentity.type].meta.filter(filterVal => filterVal.name == objVal).length > 0) {
                let valType_2 = reportState.associationTypeList[obj.query.associatedentity.type].meta.filter(filterVal => filterVal.name == objVal)[0];
                dropdownListArr.push(valType_2);
              }
              return {};
            });

          }
          const filters = obj.query.filters.map((val, index) => {
            if (val.entity_type == obj.data_type) {
              val.type = 'entity-' + val.entity_type + '-' + val.key;
              if (reportState.entityTypeList[val.entity_type] && reportState.entityTypeList[val.entity_type].meta && reportState.entityTypeList[val.entity_type].meta.filter(filterVal => filterVal.name == val.type).length > 0) {
                let valType = reportState.entityTypeList[val.entity_type].meta.filter(filterVal => filterVal.name == val.type)[0];
                val.selected_entity = JSON.stringify(valType);
                if (val.type == 'entity-procedures-record_number' || val.type == 'entity-transactions-procedure_codes') {
                  if (val.value != '') {
                    setChipsTags(val.value.split(','));
                  }
                }
                if (val.type == 'entity-policies-lob_title' || val.type == 'entity-businesslines-title' || val.type == 'entity-clients-title' || val.type == 'entity-programs-shortname') {
                  if (val.value != '') {
                    val.value = !Array.isArray(val.value) && val.value.split(',').map((objTitle) => {
                      return { title: objTitle, PK: objTitle }
                    });

                  }
                }
              }
            }
            if (val.entity_type == obj.association_type) {
              val.type = 'asso-' + val.entity_type + '-' + val.key;
              if (reportState.associationTypeList[val.entity_type] && reportState.associationTypeList[val.entity_type].meta && reportState.associationTypeList[val.entity_type].meta.filter(filterVal => filterVal.name == val.type).length > 0) {
                let valType_2 = reportState.associationTypeList[val.entity_type].meta.filter(filterVal => filterVal.name == val.type)[0];
                val.selected_entity = JSON.stringify(valType_2);
                if (val.type == 'asso-procedures-record_number') {
                  if (val.value != '') {
                    setChipsTags(val.value.split(','));
                  }
                }

                if (val.type == 'asso-businesslines-title' || val.type == 'asso-clients-title' || val.type == 'asso-programs-shortname') {
                  if (val.value != '') {
                    val.value = !Array.isArray(val.value) && val.value.split(',').map((objTitle) => {
                      return { title: objTitle, PK: objTitle }
                    });
                  }
                }
              }
            }
            return val;
          });

          obj.filterFields = filters;
          setDropdownList(dropdownListArr);
        } else {
          obj.filterFields = fieldData.filterFields;
        }
      }
      //obj.metafields= [];
      setFieldData(obj);
    }
  }, [reportState.customReport]);

  return (
    <Grid container direction="column">
      <Grid item md={12} xs={12}>          
        <DisplayBreadcrumbs items={[{title: 'Reports', link: '/reports/custom'}, {title: reportState.customReport && reportState.customReport.title ? reportState.customReport.title : 'Add New Report', link: ""}]} />
      </Grid>
      <Grid item md={12}>
        <ReportDetails data={reportState.customReport}/>
      </Grid>
      <Grid item sm={12}>
        {isLoaded && <QueryDetails data={reportState.customReport} entityList={reportState.entityTypeList} associationTypeList={reportState.associationTypeList}/>}
      </Grid>
      {/* Code Not Use */}
      {false && (<>
        <Formik
            initialValues={fieldData}
            onSubmit={onFormSubmit}
            validationSchema={schema}
            enableReinitialize={true}
          >
            {(propsFormik) => {
              const {
                values,
                touched,
                errors,
                setFieldValue,
                handleChange,
                handleBlur,
                handleSubmit,
              } = propsFormik;
              // reset checkbox for entity and association
              const resetMetaCheckBox = (type) => {
                // remove field from filter list
                if (type === 'entity-type') {
                  values.filterFields.map((val) => { boundArrayHelpers.remove(0); return val; });
                }

                if (type === 'association-type') {
                  if (values.filterFields && values.filterFields.length > 0) {
                    let asso = values.filterFields.filter((field) => field.type.includes('asso-') == false);
                    values.filterFields.map((val) => {
                      boundArrayHelpers.remove(0); return val;
                    });
                    values.filterFields = asso;
                    setFieldData(values);
                    values.filterFields.map((val) => { boundArrayHelpers.push(val); return val; });
                  }
                }
              }

              return (
                <>
                  <form onSubmit={handleSubmit} noValidate>
                    {/* Code Not Use */}
                    <ExpansionPanel
                      expanded={expandAddForm}
                      onChange={(e, exp) => setExpandAddForm(!expandAddForm)}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography variant="h6" style={{ textTransform: 'capitalize' }}>
                          Report Meta Fields
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <Grid container>
                          <Grid
                            item
                            md={12}
                            className={`${classes.bWhite} ${classes.mainPadding}`}
                          >
                            <Grid container justify="flex-end" style={{ marginBottom: 20 }}>
                              <Button
                                style={{ marginRight: '10px' }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  history.push('/reports/custom')
                                }}
                                className={classes.button}
                              >
                                { saved ? 'Close' : 'Cancel' }

                              </Button>
                              <Button
                                style={{ marginRight: '10px' }}
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={''}
                                value="save"
                                onClick={(e) => {
                                  setFieldValue('isSavePreview', false)
                                  handleSubmit(e);
                                }}
                              >
                                { saved ? 'Edit' : 'Save' }
                              </Button>
                              <Button
                                type="button"
                                value="save-preview"
                                variant="contained"
                                color="primary"
                                className={''}
                                onClick={(e) => {
                                  setFieldValue('isSavePreview', true)
                                  handleSubmit(e);
                                }}
                              >
                                Preview
                              </Button>
                              <TextField type="hidden" name="isSavePreview" value={values.isSavePreview}></TextField>
                            </Grid>

                            <Grid container direction="row" className={`${styles.formFieldsContainer}`} style={{ justifyContent: 'center', alignItems: 'center'}}>
                              <Grid item md={5} className={`${styles.nameField} ${styles.fieldPad}`}>
                                <TextField
                                  required
                                  margin="normal"
                                  fullWidth
                                  id="title"
                                  name="title"
                                  label="Name"
                                  variant="outlined"
                                  value={values.title}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={errors.title && touched.title}
                                  helperText={
                                    errors.title && touched.title && errors.title
                                  }
                                ></TextField>
                              </Grid>
                              <Grid
                                item
                                md={4}
                                className={`${styles.nameField} ${styles.fieldPad}`}
                              >
                                <FormControl
                                  required
                                  variant="outlined"
                                  className={classes.formControl}
                                  error={
                                    errors.is_public &&
                                      touched.is_public
                                      ? true
                                      : false
                                  }
                                >
                                  <InputLabel id="outlined-label-status">
                                    Status
                                  </InputLabel>
                                  <Select
                                    labelId="outlined-label-status"
                                    placeholder="Status"
                                    name="is_public"
                                    value={values.is_public}
                                    onChange={handleChange}
                                    label="Status"
                                  >
                                    <MenuItem value="">
                                      <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="y">Public</MenuItem>
                                    <MenuItem value="n">Private</MenuItem>
                                  </Select>
                                  <FormHelperText
                                    className={
                                      errors.is_public &&
                                        touched.is_public
                                        ? 'Mui-error'
                                        : ''
                                    }
                                  >
                                    {errors.is_public &&
                                      touched.is_public &&
                                      errors.is_public}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                className={`${styles.nameField} ${styles.fieldPad}`}
                              >
                                <TextField
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="version"
                                  name="version"
                                  value={values.version}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  label="Version"
                                  variant="outlined"
                                  error={errors.version && touched.version}
                                  helperText={
                                    errors.version && touched.version && errors.version
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                md={12}
                                className={`${styles.descriptionField} ${styles.fieldPad}`}
                              >
                                <TextField
                                  margin="normal"
                                  multiline
                                  rows="3"
                                  fullWidth
                                  id="description"
                                  name="description"
                                  label="Description"
                                  variant="outlined"
                                  value={values.description || ''}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                ></TextField>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel
                      expanded={expandEntities}
                      onChange={(e, exp) => setExpandEntities(!expandEntities)}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography variant="h6" style={{ textTransform: 'capitalize' }}>
                          Data
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <Grid container direction="row" className={`${styles.formFieldsContainer}`}>
                          <Grid item md={5}>
                            <FormControl
                              required
                              variant="outlined"
                              className={classes.formControl}
                              error={
                                errors.data_type &&
                                  touched.data_type
                                  ? true
                                  : false
                              }
                            >
                              <InputLabel id="outlined-label-entity-type">
                                Entity Type
                              </InputLabel>
                              <Select
                                labelId="outlined-label-entity-type"
                                placeholder="Data Type"
                                name="data_type"
                                value={values.data_type}
                                onChange={(e, value) => {
                                  setEntityFieldList([]);
                                  setDropdownList([]);
                                  setAssociationList([]);
                                  setAssociationFieldList([]);
                                  setFieldValue('association_type', '');
                                  setAssociationType('');
                                  setFieldValue('data_type', e.target.value);
                                  setEntityType(e.target.value);
                                  resetMetaCheckBox('entity-type');
                                }}
                                label="Entity Type"
                              >
                                {Object.keys(reportState.entityTypeList).length > 0 && Object.keys(reportState.entityTypeList).map((val, index) => {
                                  if (!['policies_version', 'procedures'].includes(val)) {
                                    return (<MenuItem key={index} value={val}>{reportState.entityTypeList[val] && reportState.entityTypeList[val].label}</MenuItem>)
                                  }
                                })}
                              </Select>
                              <FormHelperText
                                className={
                                  errors.data_type &&
                                    touched.data_type
                                    ? 'Mui-error'
                                    : ''
                                }
                              >
                                {errors.data_type &&
                                  touched.data_type &&
                                  errors.data_type}
                              </FormHelperText>
                            </FormControl>
                            {values.data_type !== '' && (
                              <FormGroup row>
                                <Grid item md={11}>
                                  {entityFieldList && entityFieldList.map(element => {
                                    return (<FormControlLabel
                                      key={`${element.name}`}
                                      style={{ width: '100%' }}
                                      control={
                                        <Checkbox
                                          onChange={(e, value) => {
                                            setFieldValue(e.target.name, value);
                                            if (value === false) {
                                              let filteredArray = dropdownList.filter(item => item.name !== element.name);
                                              setDropdownList(filteredArray);
                                              // remove field from filter list
                                              if (values.filterFields && values.filterFields.length > 0) {
                                                let removedFieldsIndex = values.filterFields.map((val) => (val.type)).indexOf(element.name);
                                                if (removedFieldsIndex >= 0) {
                                                  boundArrayHelpers.remove(removedFieldsIndex);
                                                }
                                              }
                                            } else {
                                              dropdownList.push(element);
                                              setDropdownList(dropdownList);
                                            }
                                          }}
                                          name={`metaFields[${element.name}]`}
                                          color="primary"
                                          defaultChecked={element.isChecked}
                                        />
                                      }
                                      label={element.label}
                                    />
                                    )
                                  })}
                                </Grid>
                              </FormGroup>
                            )}
                          </Grid>
                          <Grid item md={2} style={{ textAlign: 'center' }}>
                            <Divider style={{ width: '3px', height: '100%', display: 'inline-flex', background: '#a39c9c' }} orientation="vertical" flexItem />
                          </Grid>
                          <Grid item md={5}>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <InputLabel id="outlined-label-association-type">
                                Association Type
                              </InputLabel>
                              {associationList && (<Select
                                labelId="outlined-label-association-type"
                                placeholder="Association Type"
                                name="association_type"
                                value={associationType}
                                onChange={(e, value) => {
                                  setAssociationFieldList([]);
                                  setFieldValue('association_type', e.target.value);
                                  setAssociationType(e.target.value);
                                  resetMetaCheckBox('association-type');
                                }}
                                label="Association Type"
                              >
                                <MenuItem value="" >None</MenuItem>
                                {associationList.length > 0 && associationList.map((val, index) => {
                                  return (<MenuItem key={index} value={val.name}>{val.label}</MenuItem>)
                                })}
                              </Select>)}
                              <FormHelperText
                                className={
                                  errors.association_type &&
                                    touched.association_type
                                    ? 'Mui-error'
                                    : ''
                                }
                              >
                                {errors.association_type &&
                                  touched.association_type &&
                                  errors.association_type}
                              </FormHelperText>
                            </FormControl>
                            {values.data_type !== '' && (
                              <FormGroup row>
                                <Grid item md={12}>
                                  {associationFieldList.length > 0 && associationFieldList.map(element => {
                                    return (
                                      <FormControlLabel
                                        key={`${element.name}`}
                                        style={{ width: '48%' }}
                                        control={
                                          <Checkbox
                                            onChange={(e, value) => {
                                              setFieldValue(e.target.name, value);
                                              if (value === false) {
                                                let filteredArray = dropdownList.filter(item => item.name !== element.name);
                                                setDropdownList(filteredArray)
                                                // remove field from filter list
                                                if (values.filterFields && values.filterFields.length > 0) {
                                                  let removedFieldsIndexAsso = values.filterFields.map((val) => (val.type)).indexOf(element.name);
                                                  if (removedFieldsIndexAsso >= 0) {
                                                    boundArrayHelpers.remove(removedFieldsIndexAsso);
                                                  }
                                                }
                                              } else {
                                                dropdownList.push(element);
                                                setDropdownList(dropdownList);
                                              }
                                            }}
                                            name={`metaFields[${element.name}]`}
                                            color="primary"
                                            defaultChecked={element.isChecked}
                                          />
                                        }
                                        label={element.label}
                                      />
                                    )
                                  }
                                  )}
                                </Grid>
                              </FormGroup>
                            )}
                          </Grid>
                        </Grid>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel
                      expanded={expandFilters}
                      onChange={(e, exp) => setExpandFilters(!expandFilters)}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography variant="h6" style={{ textTransform: 'capitalize' }}>
                          Filters
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <Grid container direction="row" className={`${styles.formFieldsContainer}`}>
                          {values.filterFields && (<FieldArray
                            name="filterFields"
                            render={(arrayHelpersObj) => {
                              bindArrayHelpers(arrayHelpersObj);
                              return (
                                <>
                                  {values.filterFields && values.filterFields.length > 0 ? (
                                      values.filterFields.map(
                                        (arrayField, index) => (
                                          <React.Fragment key={index}>
                                            {index !== 0 ? (
                                              <Grid container direction="row" className={`${styles.formFieldsContainer}`}>
                                                <Grid item md={3} className={`${styles.nameField} ${styles.fieldPad}`}></Grid>
                                                <Grid item md={3} className={`${styles.nameField} ${styles.fieldPad}`}>
                                                  <FormControl
                                                    variant="outlined"
                                                    className={classes.formControl}
                                                    error={
                                                      errors.filterFields && errors.filterFields[index] && errors.filterFields[index].relation
                                                        ? true
                                                        : false
                                                    }
                                                  >
                                                    <InputLabel id={`outlined-label-relation-${index}`}>
                                                      And/Or
                                                    </InputLabel>
                                                    <Select
                                                      labelId={`outlined-label-relation-${index}`}
                                                      id={`filterFields.${index}.relation`}
                                                      placeholder="And/Or"
                                                      name={`filterFields.${index}.relation`}
                                                      onChange={handleChange}
                                                      label="And/Or"
                                                      value={arrayField.relation}
                                                      defaultValue={arrayField.relation}
                                                    >
                                                      <MenuItem value="">
                                                        <em>None</em>
                                                      </MenuItem>
                                                      <MenuItem value={'and'}>And</MenuItem>
                                                      <MenuItem value={'or'}>Or</MenuItem>
                                                    </Select>
                                                  </FormControl>
                                                </Grid>
                                              </Grid>
                                            ) : (
                                              ''
                                            )}
                                            <Grid item md={3} className={`${styles.nameField} ${styles.fieldPad}`}>
                                              <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                                error={
                                                  errors.filterFields && errors.filterFields[index] && errors.filterFields[index].type &&
                                                    touched.filterFields && touched.filterFields[index] && touched.filterFields[index].type
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <InputLabel id={`outlined-label-type-${index}`}>
                                                  Type
                                                </InputLabel>
                                                <Select
                                                  labelId={`outlined-label-type-${index}`}
                                                  id={`filterFields.${index}.type`}
                                                  placeholder="Type"
                                                  name={`filterFields.${index}.type`}
                                                  value={arrayField.type}
                                                  defaultValue={arrayField.type}
                                                  onChange={(e) => {
                                                    const totalvalue = values.filterFields && values.filterFields.filter((objVal) => objVal.type === e.target.value).length;
                                                    if (totalvalue === 0) {
                                                      const dataType = dropdownList.filter(val => val.name.includes(e.target.value));
                                                      if (dataType && dataType.length > 0) {
                                                        setFieldValue(`filterFields.${index}.selected_entity`, JSON.stringify(dataType[0]));
                                                      }

                                                      setFieldValue(e.target.name, e.target.value);
                                                    } else {
                                                      return false;
                                                    }

                                                    setFieldValue(`filterFields.${index}.operation`, '');
                                                    setFieldValue(`filterFields.${index}.value`, '');
                                                    setFieldValue(`filterFields.${index}.value`, '');
                                                  }}
                                                  label="Type"
                                                >
                                                  <MenuItem value="">
                                                    <em>None</em>
                                                  </MenuItem>
                                                  {dropdownList && dropdownList.length > 0 && dropdownList.map(element => (
                                                    <MenuItem key={element.name} value={element.name}>{element.label}</MenuItem>
                                                  ))}
                                                </Select>
                                                <TextField type="hidden" name={`filterFields.${index}.selected_entity`} value={arrayField.selected_entity} />
                                              </FormControl>
                                            </Grid>
                                            <Grid item md={1} className={`${styles.nameField} ${styles.fieldPad}`}>
                                              <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                                error={
                                                  errors.filterFields && errors.filterFields[index] && errors.filterFields[index].operation &&
                                                    touched.filterFields && touched.filterFields[index] && touched.filterFields[index].operation
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <InputLabel id={`outlined-label-operator-type-${index}`}>
                                                  Operator
                                                </InputLabel>
                                                <Select
                                                  labelId={`outlined-label-operator-type-${index}`}
                                                  id={`filterFields.${index}.operation`}
                                                  placeholder="Operator"
                                                  name={`filterFields.${index}.operation`}
                                                  value={arrayField.operation}
                                                  onChange={(e) => {
                                                    setFieldValue(e.target.name, e.target.value);

                                                  }}
                                                  label="Operator"
                                                >
                                                  {arrayField.selected_entity && operationList && operationList.length > 0 && operationList.filter(val => JSON.parse(arrayField.selected_entity).rule.includes(val.name)).map(element => (
                                                    <MenuItem key={element.name} value={element.name}>{element.label}</MenuItem>
                                                  ))}
                                                </Select>
                                              </FormControl>
                                            </Grid>

                                            <Grid item md={4} className={`${styles.nameField} ${styles.fieldPad}`}>
                                              {arrayField.operation && arrayField.operation != '' && arrayField.operation != 'null' && (<Grid container
                                                direction="row"
                                                justify="center">
                                                <Grid item md={
                                                  (arrayField.selected_entity && arrayField.operation && arrayField.operation === 'range') ? '6' : '12'
                                                } className={`${styles.fieldPad}`}>
                                                  {arrayField.type && (arrayField.type == 'entity-groups-client_id' ||
                                                    arrayField.type == 'asso-groups-client_id' ||
                                                    arrayField.type == 'entity-policies-record_type' ||
                                                    arrayField.type == 'asso-policies-record_type' ||
                                                    arrayField.type == 'entity-policies-lob_title' ||
                                                    arrayField.type == 'entity-programs-sourcing' ||
                                                    arrayField.type == 'asso-programs-sourcing' ||
                                                    arrayField.type == 'entity-instructions-record_type' ||
                                                    arrayField.type == 'asso-instructions-record_type' ||
                                                    arrayField.type == 'asso-businesslines-title' ||
                                                    arrayField.type == 'entity-businesslines-title' ||
                                                    arrayField.type == 'asso-clients-title' ||
                                                    arrayField.type == 'entity-clients-title' ||
                                                    arrayField.type == 'asso-programs-shortname' ||
                                                    arrayField.type == 'entity-programs-shortname' ||
                                                    arrayField.type == 'asso-programs-shortname' ||
                                                    arrayField.type == 'asso-programs-shortname' ||
                                                    arrayField.type == 'entity-procedures-record_type' ||
                                                    arrayField.type == 'asso-procedures-record_type' ||
                                                    arrayField.type == 'entity-procedures-record_number' ||
                                                    arrayField.type == 'asso-procedures-record_number' ||
                                                    arrayField.type == 'entity-transactions-procedure_codes' ||
                                                    arrayField.type == 'asso-programs-title' ||
                                                    arrayField.type == 'entity-programs-title') ? (<FieldCommon name={`filterFields.${index}.value`} dataCollectionType={arrayField.type} handleAddChip={handleAddChip} handleDeleteChip={handleDeleteChip} chipsTags={chipsTags} />) : (arrayField.selected_entity && arrayField.operation && (
                                                      <Field name={`filterFields.${index}.value`} id={`filterFields.${index}.value`} type={JSON.parse(arrayField.selected_entity).data_type} title={arrayField.operation === 'range' ? 'From Date' : 'Date'} component={RenderField}
                                                      className={
                                                        errors &&
                                                        errors.filterFields &&
                                                        errors.filterFields[index] &&
                                                        errors.filterFields[index].value &&
                                                          (touched &&
                                                           touched.filterFields &&
                                                           touched.filterFields[index] &&
                                                           touched.filterFields[index].value) ? 'Mui-error' : ''
                                                      }
                                                      />
                                                    ))}
                                                    {
                                                      errors &&
                                                      errors.filterFields &&
                                                      errors.filterFields[index] &&
                                                      errors.filterFields[index].value &&
                                                        (touched &&
                                                          touched.filterFields &&
                                                          touched.filterFields[index] &&
                                                          touched.filterFields[index].value) && (
                                                            <FormHelperText className="Mui-error">
                                                              {errors.filterFields[index].value}
                                                            </FormHelperText>
                                                          )
                                                    }
                                                </Grid>
                                                <Grid item md={6} className={`${styles.fieldPad}`}>
                                                  {arrayField.selected_entity && arrayField.operation && arrayField.operation === 'range' && (
                                                    <Field name={`filterFields.${index}.value_2`} id={`filterFields.${index}.value_2`} type={JSON.parse(arrayField.selected_entity).data_type} range="true" component={RenderField}
                                                    className={
                                                      errors &&
                                                      errors.filterFields &&
                                                      errors.filterFields[index] &&
                                                      errors.filterFields[index].value_2 &&
                                                        (touched &&
                                                         touched.filterFields &&
                                                         touched.filterFields[index] &&
                                                         touched.filterFields[index].value_2) ? 'Mui-error' : ''
                                                    }
                                                    />
                                                  )}

                                                  {
                                                    errors &&
                                                    errors.filterFields &&
                                                    errors.filterFields[index] &&
                                                    errors.filterFields[index].value_2 &&
                                                      (touched &&
                                                        touched.filterFields &&
                                                        touched.filterFields[index] &&
                                                        touched.filterFields[index].value_2) && (
                                                          <FormHelperText className="Mui-error">
                                                            {errors.filterFields[index].value_2}
                                                          </FormHelperText>)
                                                  }


                                                </Grid>
                                              </Grid>)}
                                            </Grid>

                                            <Grid style={{ marginLeft: '10px' }} item md={3} className={`${classes.fieldPad}`}>
                                              <Button
                                                style={{
                                                  marginTop: '13px',
                                                  marginRight: '10px',
                                                }}
                                                margin="normal"
                                                variant="contained"
                                                color="primary"
                                                onClick={() => arrayHelpersObj.remove(index)}
                                                className={classes.button}
                                              >
                                                Remove
                                              </Button>

                                              {
                                                values.filterFields.length < 12 && values.filterFields.length === index + 1 ? (
                                                  <Button
                                                    style={{ marginTop: '13px' }}
                                                    margin="normal"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => arrayHelpersObj.push({ type: '', operation: '', value: '', relation: 'and' })}
                                                    className={classes.button}
                                                  >
                                                    Add
                                                  </Button>
                                                ) : ('')
                                              }
                                            </Grid>
                                          </React.Fragment>
                                        ),
                                      )
                                    ) : (
                                      <Button
                                        style={{ marginTop: '0px' }}
                                        margin="normal"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => arrayHelpersObj.push({ type: '', operation: '', value: '', relation: 'and' })}
                                        className={classes.button}
                                      >
                                        Add Filters
                                      </Button>
                                    )
                                  }
                                </>
                              )
                            }}
                          />)}
                        </Grid>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <Grid container style={{ marginTop: '30px', marginBottom: '50px' }}>
                      <Grid item md={12} className={`${classes.mainPadding}`}>
                        <Grid container justify="flex-end">
                          <Button
                            style={{ marginRight: '10px' }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              history.push('/reports/custom')
                            }}
                            className={classes.button}
                          >
                            { saved ? 'Close' : 'Cancel' }
                          </Button>
                          <Button
                            style={{ marginRight: '10px' }}
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={''}
                            value="save"
                            onClick={(e) => {
                              setFieldValue('isSavePreview', false)
                              handleSubmit(e);
                            }}
                          >
                            { saved ? 'Edit' : 'Save' }
                          </Button>
                          <Button
                            type="button"
                            value="save-preview"
                            variant="contained"
                            color="primary"
                            className={''}
                            onClick={(e) => {
                              setFieldValue('isSavePreview', true)
                              handleSubmit(e);
                            }}
                          >
                            Preview
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Code Not Use */}
                  </form>
                </>
              );
            }}
          </Formik>
      </>)}
      {/* Code Not Use */}
    </Grid>
  );
};

export default ReportAddage;